import { HttpV1 as HTTP } from '@/request'
import store from '@/store'

/**
 * 获取用户的运存金款项
 */
export async function getDeposit() {
  return await HTTP.get(`/agent/user/${store.state.user.user.id}/deposit`)
}